import { ChatIcon, LockIcon } from "evergreen-ui";
import { RampartAuthorized } from "../rampart/RampartAuthorized";
import { FMS_CHAT_GROUP } from "../rampart/RampartUtils";
import { EmptyState } from "../common/EmptyState";

const INVITE_ONLY_SUBTITLE = "The chat beta is invite-only. Ask in #eng if you'd like access.";

// Placeholder: the chat UI lands in the next PR of this stack. The route,
// nav tab, and Rampart group gating are wired here so the feature ships
// dark and the gating can be reviewed on its own.
//
// Gated with the standard <RampartAuthorized> wrapper (same as every other
// gated page) rather than an inline userIsAuthorized check: it denies by
// default until the user resolves, so the authorized view never flashes
// during load. Server-side enforcement (the /langgraph/token 403) remains
// the real access control; this is UI hygiene.
export const FmsChatPage = () => (
    <RampartAuthorized
        requiredGroups={[FMS_CHAT_GROUP]}
        unauthorizedView={
            <EmptyState title="Not available" subtitle={INVITE_ONLY_SUBTITLE}>
                <LockIcon size={60} />
            </EmptyState>
        }
    >
        <EmptyState
            title="Coming soon"
            subtitle="The finance chat beta is rolling out shortly."
        >
            <ChatIcon size={60} />
        </EmptyState>
    </RampartAuthorized>
);
